class FaqSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.faq-search__input');
    this.empty = this.querySelector('.faq-search__empty');
    if (!this.input) return;

    this.groups = [...document.querySelectorAll('.section-faq')].map((group) => ({
      element: group,
      items: [...group.querySelectorAll('details-disclosure')].map((item) => ({
        element: item,
        haystack: FaqSearch.normalize(item.textContent),
      })),
    }));

    this.input.addEventListener('input', this.filter.bind(this));
    this.input.addEventListener('search', this.filter.bind(this));
  }

  static normalize(value) {
    return value
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  filter() {
    const query = FaqSearch.normalize(this.input.value);
    let matches = 0;

    this.groups.forEach((group) => {
      let visible = 0;

      group.items.forEach((item) => {
        const hit = query === '' || item.haystack.includes(query);
        item.element.hidden = !hit;
        if (hit) visible += 1;
      });

      group.element.hidden = visible === 0;
      matches += visible;
    });

    if (this.empty) this.empty.hidden = query === '' || matches > 0;
  }
}

if (!customElements.get('faq-search')) {
  customElements.define('faq-search', FaqSearch);
}
